import label from "../StaticLabels";

let alertItems = {
  success: {
    save: "اطلاعات شما با موفقیت ذخیره شد",
    submit: "اطلاعات مدنظر با موفقیت ثبت شد",
    edit: "اطلاعات مدنظر باموفقیت ویرایش شد",
    addUser: "کاربر جدید با موفقیت ثبت شد",
    editUser: "اطلاعات کاربر با موفقیت ویرایش شد",
    delete: "با موفقیت حذف شد",
    deleteUser: "کاربر مدنظر با موفقیت حذف شد",
    login: "به نرم‌افزار میتـــا خوش آمدید ...",
    register: "حساب کاربری شما با موفقیت ایجاد شد",
    changeStatus: "وضعیت مدنظر با موفقیت ویرایش شد",
    changeAvatar: "تصویر پروفایل بروزرسانی شد",
    editProfile: "اطلاعات پروفایل شما با موفقیت ویرایش شد",
    changePassword: "رمز عبور شما با موفقیت ویرایش شد",
    resetPassword: "رمز عبور با موفقیت بازنشانی شد",
    forgotPassword: "رمز عبور جدید ثبت و به پست الکترونیک شما ارسال شد",
    upload: "با موفقیت بارگذاری شد",
    generateCode: "کد یکبار مصرف ایجاد شد",
    closeMessage: "پیام با موفقیت بسته شد",
    addOrder: "سفارش شما با موفقیت ثبت شد",
    copyCode: "کلید با موفقیت کپی شد",
    copyTag: "برچسب با موفقیت کپی شد",
    saving: "اطلاعات ذخیره شد.",
    copyReceipt: "اطلاعات رسید در یک برگه جدید کپی شد",
    copyDraft: "اطلاعات حواله در یک برگه جدید کپی شد",
    copyDraftFromReceipt: "اطلاعات رسید در یک برگه جدید کپی شد",
    copyReceiptFromDraft: "اطلاعات حواله در یک برگه جدید کپی شد",
    send: "با موفقیت ارسال شد",
  },
  error: {
    settlementNegativeInstallable:
      "مبلغ قابل تقسیط منفی است؛ جمع تخفیف، پیش پرداخت و اعتبار از مبلغ کل بیشتر است",
    settlementInstallmentCountRequired:
      "مبلغ قابل تقسیط مثبت است؛ تعداد قسط را وارد کنید",
    settlementRowsEmpty:
      "ردیفی برای تسویه وجود ندارد؛ ابتدا «درج اقساط و تسویه» را بزنید",
    settlementRowPriceDate:
      "تاریخ همه ردیف‌ها الزامی و مبلغ آن‌ها باید بزرگتر از صفر باشد",
    access: "متاسفانه شما به این قسمت دسترسی ندارید",
    notFound: "اطلاعات مدنظر یافت نشد",
    server: "مشکلی در ارتباط با سرور وجود دارد",
    emptyFields: "لطفا موارد الزامی را وارد کنید",
    rePassword: "تکرار رمز عبور همخوانی ندارد",
    delete: "امکان حذف این مورد وجود ندارد",
    emptyLogin: "لطفا نام کاربری و رمز عبور را وارد کنید",
    email: "لطفا پست الکترونیک را به صورت صحیح وارد کنید",
    nationalCodeLength: "طول کدملی باید 10 رقم باشد",
    emptySelect: "هیچ موردی جهت انجام عملیات انتخاب نشده است",
    saleOrderLocked:
      "سفارش انصراف داده شده، تعیین وضعیت شده یا تسویه شده قابل ویرایش و حذف نیست",
    saleOrderCancelNotAllowed:
      "سفارش انصراف داده شده یا تسویه شده قابل انصراف نیست",
    saleOrderNotCanceled:
      "فقط سفارش انصراف داده شده قابل بازگردانی انصراف است",
    saveSaleOrderFirst: "برای انجام این عملیات ابتدا سفارش را ذخیره کنید",
    mergeEmptySelect: "سند یا ردیفی برای ادغام انتخاب نشده است",
    mergeVoucherNumberRequired: "فیلد شماره سند الزامی است",
    mergeDescriptionMaxLength: "روکش سند نمی‌تواند بیشتر از ۵۰۰ کاراکتر باشد",
    mergeVoucherNotFound: "سند با شماره وارد شده در لیست جاری یافت نشد",
    mergeVoucherNotMergeable: "سند انتخاب شده قابل ادغام نیست",
    validation: "اطلاعات فرم را به صورت صحیح وارد نمایید",
    occasionalLeaveMaxDays:
      "مرخصی ازدواج دائم و فوت بستگان حداکثر ۳ روز قابل ثبت است",
    reminderRequired: "فیلدهای الزامی یادآوری (تاریخ، ساعت و تاریخ اتمام) را تکمیل کنید",
    executionTimeRange: "زمان پایان باید بعد از زمان شروع باشد",
    percentRange: "فیلد «{field}» باید بین ۰ تا ۱۰۰ باشد",
    emptyCommodity: "لطفا حداقل یک کالا ثبت کنید",
    emptyAttachment:
      "برای کالاهایی که «پیوست دارد» علامت خورده باید فایل پیوست بارگذاری شود",
    emptyAttachmentKind: "برای فایل انتخاب‌شده نوع پیوست را مشخص کنید",
    commodityGroupImageUploadFailed:
      "گروه کالا ثبت شد ولی بارگذاری تصویر انجام نشد؛ از فرم ویرایش دوباره تلاش کنید",
    attachmentUploadFailed:
      "نوبت پیوست ثبت شد ولی بارگذاری فایل انجام نشد؛ با دکمه «تلاش مجدد آپلود» دوباره تلاش کنید",
    orderCommodityAttachmentNotFound: "برای این کالا نوبت پیوستی ثبت نشده است",
    mapNotUploaded:
      "فایل نقشه این نوبت بارگذاری نشده است؛ امکان تایید وجود ندارد",
    emptyAdvancePerson: "لطفا حداقل یک پرسنل به مساعده اضافه کنید",
    incompleteRow: "ابتدا فیلدهای الزامی سطر جاری را کامل کنید",
    saveFormFirst: "ابتدا اطلاعات فرم را ثبت کنید",
    saleLineTeamRequired:
      "تیم فروش این خط فروش مشخص نشده است؛ ابتدا از «ویرایش» آن را انتخاب کنید",
    voucherIssued:
      "برای این رکورد سند حسابداری صادر شده است؛ ابتدا سند را حذف کنید",
    noVoucherIssued: "برای این برگه سند حسابداری صادر نشده است",
    duplicateAdvancePerson: "این پرسنل قبلا در همین مساعده ثبت شده است",
    userFields: "لطفا نام کاربر را انتخاب کنید",
    isSupervisor:
      "تنها یک شخص در گروه می‌تواند به عنوان سرپرست گروه انتخاب شود",
    validatBranch: "لطفا یک شعبه انتخاب نمایید",
    validatGroup: "لطفا یک گروه انتخاب نمایید",
    validatWares: "حداقل یک انبار انتخاب نمایید",
    validatUserPersons: "حداقل یک شخص یا گروه شخص انتخاب نمایید",
    validatAccounts: "حداقل یک حساب انتخاب نمایید",
    validatMembersGroup: "حداقل یک عضو برای گروه انتخاب نمایید",
    chooseCommodity: "لطفا کالای مورد نظر را انتخاب کنید",
    giftOrDiscount: "برای هدیه، کالای هدیه یا مبلغ تخفیف را وارد کنید",
    totalCount: "مقدار کل نمی تواند 0 باشد",
    totalConfirmCount: "مقدار تایید کل نمی تواند 0 باشد",
    sumCount: "مجموع تعدادها بیشتر از باقی‌مانده است",
    receiptConfirm: "به دلیل قطعی بودن رسید امکان ویرایش وجود ندارد",
    paymentRequestConfirm:
      "به دلیل تایید شدن درخواست پرداخت امکان ویرایش وجود ندارد",
    receiptNotConfirm: "این رسید قطعی نشده است",
    draftNotConfirm: "این حواله قطعی نشده است",
    emptyDescription: "لطفا توضیحات را وارد کنید",
    nothingToCopy: "برای کپی کردن، اطلاعاتی در این برگه وجود ندارد",
    selectReceipt: "لطفا رسید مورد نظر را انتخاب کنید",
    selectDraft: "لطفا حواله مورد نظر را انتخاب کنید",
    draftConfirm: "به دلیل قطعی بودن حواله امکان ویرایش وجود ندارد",
    selectCommodity: "لطفا حداقل یک کالا انتخاب کنید",
    selectDateRange: "لطفا «از تاریخ» و «تا تاریخ» را انتخاب کنید",
    selectBaseDate: "لطفا تاریخ مبنا را انتخاب کنید",
    similarWare: "انبار مقصد باید با انبار مبدأ متفاوت باشد",
    chooseSourceWare: "لطفا انبار مبدا مورد نظر را انتخاب کنید",
    chooseDestinationWare: "لطفا انبار مقصد مورد نظر را انتخاب کنید",
    insertMobileNumber: "لطفا شماره همراه را وارد کنید",
    validationContact: "اطلاعات فرم رابط را به صورت صحیح وارد نمایید",
    validationDiscount:
      "حداقل یکی از موارد «تخصیص اعتبار هدیه» یا «تخصیص کد تخفیف» را انتخاب نمایید",
    noCustomerClub: "کاربر موردنظر وجود ندارد",
    noOption: "گزینه مورد نظر را وارد نمایید",
    minOpetionParameter: "حداقل یک گزینه برای پارامتر مورد نظر تعریف کنید",
    emptyBuyer: "فقط برای مواردی که مأمور خرید دارند امکان چاپ وجود دارد",
    validationFinancialRatio: "لطفا نسبت مالی را انتخاب کنید",
    numeratorDenominator: "لطفا برای نسبت مالی صورت و مخرج را تنظیم کنید.",
    selectBank: "لطفا ابتدا یک بانک انتخاب کنید ",
    noCustomerPurchase: "تابحال خریدی برای این مشتری ثبت نشده است",
    purchasePrice: "مبلغ خرید نمی‌تواند 0 باشد",
    validationPrice: "مبلغ نمی‌تواند 0 باشد",
    validationFirstAmount: "موجودی اولیه نمی‌تواند 0 باشد",
    emptyPayerInfo:
      "لطفا یکی از مشخصات پرداخت کننده (شخص/صندوق/بانک/حساب) را انتخاب کنید",
    warningCode: "در کپی کردن کلید خطایی وجود دارد",
    warningTag: "در کپی کردن برچسب خطایی وجود دارد",
    emptyData: "هیچ موردی جهت انجام عملیات وجود ندارد",
    emptyMaterial: "لطفا حداقل یک ماده مصرفی ثبت کنید",
    validationWeight: "مقدار وزن ها نمیتواند 0 باشد",
    faLetter: "لطفا حروف را به فارسی وارد کنید",
    atLeastOne: "حداقل یک مورد را انتخاب کنید",
    selectCustomer: "لطفا روی مشتری مورد نظر کلیک کنید",
    selectAddMinus: "لطفا روی اضافات/کسورات مورد نظر کلیک کنید",
    nodeDepthZeroToTen: "شماره سطح حساب باید بین 0 تا 10 باشد",
    payerCondition: `یکی از فیلد‌های مربوط به پرداخت کننده باید وارد شود \n ${label.form.fromAccount} \n ${label.form.payer} \n ${label.form.fromBankCashAccount}`,
    limitPrice: "فیلد مبلغ باید بزرگتر از صفر باشد",
    selectStatus: "لطفا یک وضعیت انتخاب نمایید.",
    greaterThanZero: "مبلغ نقدی و مبلغ چک باید بزرگتر از صفر باشد",
    validationMaxOffPrice: "حداکثر مقدار تخفیف نمی‌تواند بیشتر از 100 باشد.",
    validationOffPercent: "درصد تخفیف نمی‌تواند بیشتر از 100 باشد.",
    emptyShowData: "موردی جهت نمایش وجود ندارد",
    emptyColumns: "اطلاعات موردنیاز را تکمیل کنید.",
    validationInventory: "امکان صدور سند برای موجودی صفر وجود ندارد.",
    validationBranchFiscalYear: "انتخاب شعبه و سال مالی الزامی است.",
    emptyCutWeightPercentage: "لطفا حداقل یک درصد وزن به کات نورد سرد ثبت کنید",
    emptyProduceOrder: "لطفا شماره دستور تولید رو وارد کنید",
    existingUser: "کاربر قبلاً ثبت شده است",
    hasVoucherError:
      "برخی از برگه‌های انتخاب شده دارای شماره سند هستند،<br>" +
      "امکان صدور سند برای آن‌ها وجود ندارد.",
    changeLang: "لطفا زبان صفحه کلید خود را روی زبان انگلیسی قرار دهید",
    emptyWareAndWaretype: "لطفا انبار و نوع رسید انبار را انتخاب کنید",
    emptyWareAndDraftType: "لطفا انبار و نوع حواله انبار را انتخاب کنید",
    noPaper: "شماره برگه وارد شده یافت نشد",
    noChequeNumber: "شماره چک وارد شده یافت نشد",
    hasVoucherPaymentError:
      "برخی از برگه‌های انتخاب شده دارای شماره سند نیستند<br>" +
      "امکان صدور سند پرداخت حقوق برای آن‌ها وجود ندارد.",
    voucherPaymentDelete: "به علت صدور سند پرداخت امکان حذف وجود ندارد",
    discrepancyInsuranceWageAndWage: " دستمزد و دستمزد بیمه مغایرت دارند.",
    noPersonnelImage: "تصویری برای این پرسنل ثبت نشده است.",
    sameSourceDestination: "مبدا و مقصد نمیتواند یکی باشد.",
    voucherNotFound: "سندی با این شماره یافت نشد",
    emptyPermitRows: "برای هیچ سطری مقدار تایید جاری وارد نشده است",
    emptyDraftRows: "برای هیچ سطری مقدار حواله وارد نشده است",
    permitNotDeletable:
      "برخی از مجوزهای انتخاب شده به علت حواله شدن قابل حذف نیستند",
    draftHasSaleFactor:
      "برای برخی از حواله های انتخاب شده فاکتور فروش صادر شده است، ابتدا فاکتور را حذف کنید",
  },
};

export default alertItems;
